import type { ILayerBehavior, ILayerProps } from '@/version-types';

export const resolveCustomLoading = (behavior: ILayerBehavior | undefined, layer: ILayerProps) => {
    if (!behavior?.customLoading) {
        return {
            handled: false,
            node: null,
        } as const;
    }

    return {
        handled: true,
        node: behavior.customLoading(layer),
    } as const;
};
